import { GraphUtils } from '@helpers/graph.helper';
import { Sensor, dataChart } from './sensor';
import { Router } from '@angular/router';

export class PulseSensor extends Sensor {
  public waterHourGraph: any;
  public waterGraph: any;
  public waterMonthGraph: any;

  private waterHourSensor: any[];
  private waterSensor: any[];
  private waterMonthSensor: any[];

  constructor(router: Router, url: string, alerstActive: boolean) {
    super(router, url, alerstActive);
    this.waterGraph = null;

    this.waterSensor = [[], [], []];
    this.waterMonthSensor = [[], [], []];
    this.waterHourSensor = [[], [], []];
  }

  public hasHourWaterSensor(pos: number): boolean {
    return this.waterHourSensor[pos - 1].length > 0;
  }

  public getHourWaterSensor(pos: number): any {
    const realPos: number = this.waterHourSensor[pos - 1].length - 1;
    return this.waterHourSensor[pos - 1][realPos][1] ?? null;
  }

  public hasWaterSensor(pos: number): boolean {
    return this.waterSensor[pos - 1].length > 0;
  }

  public getWaterSensor(pos: number): any {
    const realPos: number = this.waterSensor[pos - 1].length - 1;
    return this.waterSensor[pos - 1][realPos][1] ?? null;
  }

  public hasMonthWaterSensor(pos: number): boolean {
    return this.waterMonthSensor[pos - 1].length > 0;
  }

  public getMonthWaterSensor(pos: number): any {
    const realPos: number = this.waterMonthSensor[pos - 1].length - 1;
    return this.waterMonthSensor[pos - 1][realPos][1] ?? null;
  }

  public prepareData(): void {
    for (const element of this.data) {
      // Day
      const date = new Date(element.date);
      let currentVal = this.waterSensor[element.position].find((e) => e[0] == GraphUtils.getDay(date));
      if (currentVal) {
        currentVal[1] += element.water;
      } else {
        this.waterSensor[element.position].push([
          GraphUtils.getDay(date),
          element.water,
        ]);
      }
      // Month
      const date2 = new Date(element.date);
      let currentVal2 = this.waterMonthSensor[element.position].find((e) => e[0] == GraphUtils.getMoth(date2));
      if (currentVal2) {
        currentVal2[1] += element.water;
      } else {
        this.waterMonthSensor[element.position].push([
          GraphUtils.getMoth(date2),
          element.water,
        ]);
      }
      // Hour
      const date3 = new Date(element.date);
      let currentVal3 = this.waterHourSensor[element.position].find((e) => e[0] == GraphUtils.getHour(date3));
      if (currentVal3) {
        currentVal3[1] += element.water;
      } else {
        this.waterHourSensor[element.position].push([
          GraphUtils.getHour(date3),
          element.water,
        ]);
      }
    }
  }

  public setCharts(): void {
    this.waterGraph = this.getConfigChar(
      'pulse',
      this.getChartSeries('m3_', this.waterSensor),
      this.getRanges('8_value_daily'),
      this.getLimits('8_value_daily'),
      'column'
    );
    this.waterHourGraph = this.getConfigChar(
      'pulseHour',
      this.getChartSeries('Pot', this.waterHourSensor),
      this.getRanges('8_value_hour'),
      this.getLimits('8_value_hour'),
      'column'
    );
    this.waterMonthGraph = this.getConfigChar(
      'pulseMonth',
      this.getChartSeries('Pot', this.waterMonthSensor),
      this.getRanges('8_value_monthly'),
      this.getLimits('8_value_monthly'),
      'column'
    );
  }

  public static getVariables(): any[] {
    return [
      { title: 'Consumo de agua hora', value: '8_value_hour' },
      { title: 'Consumo de agua dia', value: '8_value_daily' },
      { title: 'Consumo de agua mes', value: '8_value_monthly' }
    ];
  }
}